(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["byd-producto"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.byd-producto-wrapper');
  if(!root)return;
  var modal=root.querySelector('#order-form');
  if(!modal)return; /* sin metafield -> fallback, no hay form */
  var CHECKOUT=(modal.getAttribute('data-checkout')||'').trim();

  var intervals=[];
  function fmt(n){return '$'+n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.');}
  var WA_PHONE='56981662116';
  var PRODUCT_NAME=(modal.getAttribute('data-pname')||'').trim();
  var regiones={"Arica y Parinacota":["Arica","Camarones","Putre","General Lagos"],"Tarapaca":["Iquique","Alto Hospicio","Pozo Almonte","Pica","Huara"],"Antofagasta":["Antofagasta","Calama","Tocopilla","Mejillones","Taltal"],"Atacama":["Copiapo","Vallenar","Caldera","Diego de Almagro","Chanaral"],"Coquimbo":["Coquimbo","La Serena","Ovalle","Illapel","Monte Patria"],"Valparaiso":["Vina del Mar","Valparaiso","Quilpue","Villa Alemana","San Antonio","Concon","Quillota","Los Andes","San Felipe"],"Metropolitana de Santiago":["Puente Alto","Maipu","Santiago","La Florida","Las Condes","Providencia","Nunoa","Vitacura","La Reina","San Miguel","Recoleta","Penalolen","San Bernardo","Pudahuel","Quilicura","Estacion Central","Macul","Independencia","Lo Barnechea","Renca"],"O'Higgins":["Rancagua","San Fernando","Rengo","Machali","Santa Cruz"],"Maule":["Talca","Curico","Linares","Maule","Constitucion"],"Nuble":["Chillan","San Carlos","Chillan Viejo","Coihueco","Bulnes"],"Biobio":["Concepcion","Los Angeles","Talcahuano","San Pedro de la Paz","Coronel","Chiguayante"],"La Araucania":["Temuco","Padre Las Casas","Villarrica","Angol","Lautaro"],"Los Rios":["Valdivia","La Union","Panguipulli","Rio Bueno","Mariquina"],"Los Lagos":["Puerto Montt","Osorno","Puerto Varas","Castro","Ancud"],"Aysen":["Coyhaique","Puerto Aysen","Cisnes","Chile Chico","Cochrane"],"Magallanes":["Punta Arenas","Puerto Natales","Porvenir","Cabo de Hornos","Primavera"]};
  var REGCODES={"Arica y Parinacota":"AP","Tarapaca":"TA","Antofagasta":"AN","Atacama":"AT","Coquimbo":"CO","Valparaiso":"VS","Metropolitana de Santiago":"RM","O'Higgins":"LI","Maule":"ML","Nuble":"NB","Biobio":"BI","La Araucania":"AR","Los Rios":"LR","Los Lagos":"LL","Aysen":"AI","Magallanes":"MA"};
  var MAKE_WEBHOOK='https://hook.us2.make.com/wcha5ehnhi0mrtm1b9x80m1bss5ltb4g';

  /* ===== BUNDLES desde los data-* del hero (no hardcode) ===== */
  var heroPacks=root.querySelectorAll('#byd-packs .byd-pack');
  var bundles=[];
  heroPacks.forEach(function(p){
    bundles.push({
      idx:parseInt(p.dataset.idx),
      price:parseInt(p.dataset.price)||0,
      variant:p.dataset.variant||'',
      name:p.dataset.name||(p.querySelector('.byd-pack-name')?p.querySelector('.byd-pack-name').textContent:''),
      priceDisplay:p.dataset.priceDisplay||fmt(parseInt(p.dataset.price)||0),
      compareDisplay:p.dataset.compareDisplay||''
    });
  });
  /* índice por defecto = el .selected renderizado, o 0 */
  var sel=0;
  heroPacks.forEach(function(p){if(p.classList.contains('selected'))sel=parseInt(p.dataset.idx);});
  function cur(){return bundles[sel]||bundles[0]||{price:0,name:'',priceDisplay:'',compareDisplay:'',variant:''};}

  /* % OFF calculado */
  function offPct(b){
    var cmp=b.compareDisplay?parseInt(String(b.compareDisplay).replace(/[^0-9]/g,'')):0;
    if(cmp&&b.price&&cmp>b.price){return Math.round((1-(b.price/cmp))*100);}
    return 0;
  }

  function paint(){
    var b=cur();
    /* EasySell lee la variante activa desde la URL: sincroniza el pack elegido */
    if(CHECKOUT==='easysell'&&b.variant){try{history.replaceState(null,'',location.pathname+'?variant='+b.variant);}catch(e){}}
    /* sincroniza TODOS los grupos de packs (hero, final, modal) */
    root.querySelectorAll('.byd-pack').forEach(function(p){p.classList.toggle('selected',parseInt(p.dataset.idx)===sel);});
    /* precio hero */
    var pn=root.querySelector('#byd-price-now');if(pn)pn.textContent=b.priceDisplay;
    var po=root.querySelector('#byd-price-old');if(po)po.textContent=b.compareDisplay||'';
    var pf=root.querySelector('#byd-price-off');
    if(pf){var o=offPct(b);if(o>0){pf.textContent='-'+o+'%';pf.style.display='';}else{pf.style.display='none';}}
    /* final */
    var fn=root.querySelector('#byd-final-new');if(fn)fn.textContent=b.priceDisplay;
    var fo=root.querySelector('#byd-final-old');if(fo)fo.textContent=b.compareDisplay||'';
    /* sticky */
    var sn=root.querySelector('#byd-sticky-name');if(sn)sn.textContent=b.name;
    var sp=root.querySelector('#byd-sticky-price');if(sp)sp.textContent=b.priceDisplay;
    /* modal summary */
    var sumP=root.querySelector('#rf-sum-pack');if(sumP)sumP.textContent=b.name;
    var sumT=root.querySelector('#rf-sum-total');if(sumT)sumT.textContent=b.priceDisplay;
  }
  var atcFired={};
  function trackATC(b){
    if(typeof fbq==='undefined'||!b)return;
    var k=String(b.idx);
    if(atcFired[k])return;atcFired[k]=true;
    fbq('track','AddToCart',{content_name:PRODUCT_NAME+' '+b.name,content_ids:[String(b.variant||'')],content_type:'product',value:b.price,currency:'CLP'});
  }
  root.querySelectorAll('.byd-pack').forEach(function(p){p.addEventListener('click',function(e){
    e.preventDefault();
    sel=parseInt(p.dataset.idx);
    paint();
    trackATC(cur());
  });});
  paint();
  /* ViewContent al aterrizar: la señal mínima que Meta necesita para optimizar */
  if(typeof fbq!=='undefined'){var vcB=cur();fbq('track','ViewContent',{content_name:PRODUCT_NAME,content_type:'product',content_ids:[String(vcB.variant||'')],value:vcB.price,currency:'CLP'});}

  /* ===== COUNTDOWN ===== */
  var end;try{var st=sessionStorage.getItem('bydp_cd');if(st&&parseInt(st)>Date.now())end=parseInt(st);}catch(e){}
  if(!end){end=Date.now()+6*3600*1000;try{sessionStorage.setItem('bydp_cd',end);}catch(e){}}
  var cd={h1:'cd-h1',h2:'cd-h2',m1:'cd-m1',m2:'cd-m2',s1:'cd-s1',s2:'cd-s2'};
  Object.keys(cd).forEach(function(k){cd[k]=root.querySelector('#'+cd[k]);});
  function pad(n){var s=String(Math.max(0,n));return s.length===1?'0'+s:s;}
  function tick(){var t=Math.max(0,Math.floor((end-Date.now())/1000));var h=pad(Math.floor(t/3600)),m=pad(Math.floor(t%3600/60)),sx=pad(t%60);if(cd.h1){cd.h1.textContent=h[0];cd.h2.textContent=h[1];cd.m1.textContent=m[0];cd.m2.textContent=m[1];cd.s1.textContent=sx[0];cd.s2.textContent=sx[1];}}
  tick();intervals.push(setInterval(tick,1000));

  /* ===== GALERÍA: miniaturas ===== */
  var mainImg=root.querySelector('#byd-main-img');
  root.querySelectorAll('.byd-thumb').forEach(function(t){t.addEventListener('click',function(){
    if(mainImg&&t.dataset.img)mainImg.src=t.dataset.img;
    root.querySelectorAll('.byd-thumb').forEach(function(x){x.classList.remove('active');});
    t.classList.add('active');
  });});

  /* ===== NAV MÓVIL ===== */
  var mnav=root.querySelector('#byd-mnav');
  var burger=root.querySelector('[data-toggle-mnav]');
  if(burger&&mnav)burger.addEventListener('click',function(){mnav.classList.toggle('open');});
  root.querySelectorAll('[data-close-mnav]').forEach(function(a){a.addEventListener('click',function(){if(mnav)mnav.classList.remove('open');});});

  /* ===== ACORDEÓN FAQ ===== */
  root.querySelectorAll('[data-acc]').forEach(function(btn){btn.addEventListener('click',function(){btn.parentElement.classList.toggle('open');});});

  /* ===== REGIONES -> COMUNA ===== */
  var rSel=root.querySelector('#rf-region'),cSel=root.querySelector('#rf-comuna');
  Object.keys(regiones).forEach(function(r){var o=document.createElement('option');o.value=r;o.textContent=r;rSel.appendChild(o);});
  rSel.addEventListener('change',function(){cSel.innerHTML='<option value="">Selecciona</option>';cSel.disabled=!this.value;(regiones[this.value]||[]).forEach(function(c){var o=document.createElement('option');o.value=c;o.textContent=c;cSel.appendChild(o);});});

  /* ===== MODAL abrir/cerrar ===== */
  var icFired=false;
  function openForm(){modal.classList.add('open');document.body.style.overflow='hidden';if(mnav)mnav.classList.remove('open');
    var b=cur();
    if(typeof fbq!=='undefined'&&!icFired){icFired=true;fbq('track','InitiateCheckout',{content_name:PRODUCT_NAME,content_ids:[String(b.variant||'')],content_type:'product',value:b.price,currency:'CLP',num_items:1});}
    trackATC(b);
  }
  function closeForm(){modal.classList.remove('open');document.body.style.overflow='';}
  if(CHECKOUT==='easysell'){
    /* EasySell COD: los CTA abren el popup de la app (clase oficial es-popup-button-overwrite).
       El pixel se dispara igual que con el modal propio (InitiateCheckout + AddToCart). */
    root.querySelectorAll('[data-open-form]').forEach(function(b){
      b.classList.add('es-popup-button-overwrite');
      b.addEventListener('click',function(){
        var bb=cur();
        if(typeof fbq!=='undefined'&&!icFired){icFired=true;fbq('track','InitiateCheckout',{content_name:PRODUCT_NAME,content_ids:[String(bb.variant||'')],content_type:'product',value:bb.price,currency:'CLP',num_items:1});}
        trackATC(bb);
      });
    });
  }else{
    root.querySelectorAll('[data-open-form]').forEach(function(b){b.addEventListener('click',openForm);});
  }
  root.querySelectorAll('[data-close-form]').forEach(function(b){b.addEventListener('click',closeForm);});
  modal.addEventListener('click',function(e){if(e.target===modal)closeForm();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeForm();});

  /* ===== STICKY ===== */
  var sticky=root.querySelector('#byd-sticky');
  if(sticky){sticky.classList.add('show');} /* siempre visible (como el sticky "Comprar" del competidor) */

  /* ===== VALIDACIÓN + SUBMIT ===== */
  function validRut(rut){var c=rut.replace(/[^0-9kK]/g,'').toUpperCase();if(c.length<2)return false;var dv=c.slice(-1),b=c.slice(0,-1),su=0,m=2;for(var i=b.length-1;i>=0;i--){su+=parseInt(b[i])*m;m=m===7?2:m+1;}var e=11-(su%11);var x=e===11?'0':e===10?'K':''+e;return dv===x;}
  var rutInput=root.querySelector('#rf-rut');
  rutInput.addEventListener('input',function(){var r=this.value.replace(/[^0-9kK]/g,'').toUpperCase();if(!r){this.value='';return;}var dv=r.slice(-1),b=r.slice(0,-1),o='',c=0;if(!b){this.value=dv;return;}for(var i=b.length-1;i>=0;i--){o=b[i]+o;if(++c===3&&i>0){o='.'+o;c=0;}}this.value=o+'-'+dv;});
  function setErr(id,on){var el=root.querySelector('#'+id);if(!el)return;var f=el.closest('.byd-f');if(f)f.classList.toggle('err',on);}
  function val(id){var el=root.querySelector('#'+id);return el?el.value:'';}

  function getCookie(n){var m=document.cookie.match('(^|;)\\s*'+n+'\\s*=\\s*([^;]+)');return m?decodeURIComponent(m.pop()):'';}

  root.querySelector('#rf-submit').addEventListener('click',function(){
    var btn=this;
    if(btn.disabled)return;
    var nombre=val('rf-nombre').trim();
    var tel=val('rf-tel').replace(/\s+/g,'');
    var rut=val('rf-rut').trim();
    var region=val('rf-region');
    var comuna=val('rf-comuna');
    var dir=val('rf-dir').trim();
    var email=val('rf-email').trim();
    var ok=true;
    if(nombre.length<2){setErr('rf-nombre',true);ok=false;}else setErr('rf-nombre',false);
    if(!/^9\d{8}$/.test(tel)){setErr('rf-tel',true);ok=false;}else setErr('rf-tel',false);
    if(!validRut(rut)){setErr('rf-rut',true);ok=false;}else setErr('rf-rut',false);
    if(!region){setErr('rf-region',true);ok=false;}else setErr('rf-region',false);
    if(!comuna){setErr('rf-comuna',true);ok=false;}else setErr('rf-comuna',false);
    if(dir.length<3){setErr('rf-dir',true);ok=false;}else setErr('rf-dir',false);
    if(email&&!/.+@.+\..+/.test(email)){setErr('rf-email',true);ok=false;}else setErr('rf-email',false);
    if(!ok){var fe=modal.querySelector('.byd-f.err');if(fe&&fe.scrollIntoView)fe.scrollIntoView({behavior:'smooth',block:'center'});return;}
    var b=cur();
    var now=new Date();var oid='BYD-'+now.getTime().toString(36).toUpperCase();
    var full=[dir,comuna,region].filter(Boolean).join(', ');
    var nota='Cliente: '+nombre+' | Tel: +56 '+tel+' | RUT: '+rut+' | Direccion: '+full+' | Producto: '+PRODUCT_NAME+' '+b.name+' | Total: '+b.priceDisplay+' | Envio: Gratis'+(email?' | Email: '+email:'')+' | Ref: '+oid;
    var data={producto:PRODUCT_NAME,nombre:nombre,telefono:'+56 '+tel,rut:rut,email:email,direccion:full,calle:dir,region:region,regionCode:REGCODES[region]||'',comuna:comuna,pack:b.name,precio:b.priceDisplay,envio:'Envio Gratis',nota:nota,fecha:now.toLocaleDateString('es-CL'),hora:now.toLocaleTimeString('es-CL',{hour:'2-digit',minute:'2-digit'}),orderId:oid,variantId:b.variant,totalNum:b.price,eventId:oid,fbp:getCookie('_fbp'),fbc:getCookie('_fbc'),userAgent:navigator.userAgent,sourceUrl:location.href};
    var wa=encodeURIComponent('Hola! Quiero pedir:\n'+oid+'\nProducto: '+PRODUCT_NAME+' '+b.name+'\nTotal: '+b.priceDisplay+'\nNombre: '+nombre+'\nRUT: '+rut+'\nTel: +56 '+tel+'\nDireccion: '+full);
    var btnTxt=btn.textContent;
    btn.disabled=true;btn.textContent='Enviando pedido…';

    function onSuccess(){
      /* Purchase con eventID = orderId, para deduplicar con el evento CAPI que envía Make */
      if(typeof fbq!=='undefined')fbq('track','Purchase',{value:b.price,currency:'CLP',content_name:PRODUCT_NAME+' '+b.name,content_ids:[String(b.variant||'')],content_type:'product',order_id:oid},{eventID:oid});
      if(email){try{var sf=new FormData();sf.append('form_type','customer');sf.append('utf8','✓');sf.append('contact[email]',email);sf.append('contact[tags]','newsletter,cod-form');fetch('/contact',{method:'POST',body:sf,keepalive:true}).catch(function(){});}catch(e){}}
      root.querySelector('#byd-form-body').innerHTML='<div style="text-align:center;padding:1.5rem 0"><div style="font-size:3rem">✅</div><h2 style="font-family:\'Fraunces\',Georgia,serif;font-size:1.4rem;color:#0F172A;font-weight:900;margin:.25rem 0">¡Pedido Recibido!</h2><p style="color:#16A34A;font-weight:600;font-size:.9rem;margin-bottom:1rem">Te contactaremos en menos de 2 horas para confirmar.</p><div style="background:#F8FAFC;border-radius:10px;padding:1rem;text-align:left;font-size:.85rem;margin-bottom:1rem"><p><strong>Pedido:</strong> '+oid+'</p><p><strong>Producto:</strong> '+PRODUCT_NAME+' '+b.name+'</p><p><strong>Total a pagar:</strong> '+b.priceDisplay+'</p></div><a href="https://wa.me/'+WA_PHONE+'?text='+wa+'" style="display:inline-flex;gap:.4rem;background:#25D366;color:#fff;font-weight:700;font-size:.9rem;padding:.7rem 1.4rem;border-radius:10px;text-decoration:none">💬 Conf&iacute;rmalo por WhatsApp →</a></div>';
    }
    function onFail(){
      btn.disabled=false;btn.textContent=btnTxt;
      var el=root.querySelector('#rf-neterr');
      if(!el){el=document.createElement('div');el.id='rf-neterr';el.style.cssText='background:#FEF2F2;border:1px solid #FCA5A5;color:#B91C1C;border-radius:10px;padding:.7rem .9rem;font-size:.85rem;margin-top:.6rem';btn.parentNode.insertBefore(el,btn.nextSibling);}
      el.style.display='';
      el.innerHTML='No pudimos enviar tu pedido por un problema de conexi&oacute;n. Int&eacute;ntalo de nuevo o <a href="https://wa.me/'+WA_PHONE+'?text='+wa+'" target="_blank" rel="noopener" style="color:#B91C1C;font-weight:700;text-decoration:underline">p&iacute;delo por WhatsApp →</a>';
    }
    function send(){return fetch(MAKE_WEBHOOK,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)}).then(function(r){if(!r.ok)throw new Error('HTTP '+r.status);});}
    function withTimeout(p,ms){return Promise.race([p,new Promise(function(_,rej){setTimeout(function(){rej(new Error('timeout'));},ms);})]);}
    withTimeout(send(),12000).then(onSuccess).catch(function(){
      withTimeout(send(),12000).then(onSuccess).catch(onFail);
    });
  });

  /* ===== RESEÑAS: opinión del usuario (solo su propio navegador/sesión) ===== */
  (function(){
    var grid=root.querySelector('#byd-rev-grid');if(!grid)return;
    var handle=(location.pathname.split('/').filter(Boolean).pop()||'p');
    var KEY='byd_rev_'+handle;
    function esc(s){var dv=document.createElement('div');dv.textContent=s;return dv.innerHTML;}
    function stars(n){n=Math.max(1,Math.min(5,n|0));var s='';for(var i=0;i<5;i++){s+=(i<n?'★':'☆');}return s;}
    function card(r){var dv=document.createElement('div');dv.className='byd-revcard byd-revcard-mine';dv.innerHTML='<span class="byd-rev-tag">Tu opinión</span><div class="byd-stars">'+stars(r.stars)+'</div><p class="byd-rev-text">"'+esc(r.text)+'"</p><p class="byd-rev-name">'+esc(r.name)+(r.city?' · '+esc(r.city):'')+'</p>';return dv;}
    var saved=[];try{saved=JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){}
    saved.forEach(function(r){grid.insertBefore(card(r),grid.firstChild);});
    var picks=root.querySelectorAll('#byd-rev-stars span'),rating=5;
    function paint(){picks.forEach(function(s){s.classList.toggle('on',parseInt(s.dataset.star,10)<=rating);});}
    picks.forEach(function(s){s.addEventListener('click',function(){rating=parseInt(s.dataset.star,10);paint();});});
    paint();
    var btn=root.querySelector('#byd-rev-submit'),note=root.querySelector('#byd-rev-note');
    if(btn){btn.addEventListener('click',function(){
      var nm=(root.querySelector('#byd-rev-name').value||'').trim();
      var ci=(root.querySelector('#byd-rev-city').value||'').trim();
      var tx=(root.querySelector('#byd-rev-text').value||'').trim();
      if(nm.length<2||tx.length<5){if(note){note.textContent='Escribe tu nombre y tu opinión 🙂';note.style.color='var(--byd-red)';}return;}
      var r={name:nm,text:tx,stars:rating,city:ci};
      saved.push(r);try{localStorage.setItem(KEY,JSON.stringify(saved));}catch(e){}
      grid.insertBefore(card(r),grid.firstChild);
      root.querySelector('#byd-rev-name').value='';root.querySelector('#byd-rev-city').value='';root.querySelector('#byd-rev-text').value='';rating=5;paint();
      if(note){note.textContent='¡Gracias! Tu opinión quedó publicada ✅';note.style.color='var(--byd-green)';}
      if(typeof fbq!=='undefined'){fbq('trackCustom','LeaveReview',{handle:handle});}
    });}
  })();

  /* ===== limpieza de intervals ===== */
  document.addEventListener('shopify:section:unload',function(e){
    if(e.target===root||(root&&root.contains(e.target))){intervals.forEach(clearInterval);intervals=[];}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["byd-shrine-producto"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var section = document.querySelector('.bsh-shrine-section');
  if (!section) return;
  var modal = section.querySelector('#bsh-order-form');
  if (!modal) return;
  var CHECKOUT = (modal.getAttribute('data-checkout') || '').trim();

  var WA = '56981662116';
  var WEBHOOK = 'https://hook.us2.make.com/wcha5ehnhi0mrtm1b9x80m1bss5ltb4g';
  var PNAME = (modal.getAttribute('data-pname') || '').trim();

  var REGIONES = {"Arica y Parinacota":["Arica","Camarones","Putre","General Lagos"],"Tarapaca":["Iquique","Alto Hospicio","Pozo Almonte","Pica","Huara"],"Antofagasta":["Antofagasta","Calama","Tocopilla","Mejillones","Taltal"],"Atacama":["Copiapo","Vallenar","Caldera","Diego de Almagro","Chanaral"],"Coquimbo":["Coquimbo","La Serena","Ovalle","Illapel","Monte Patria"],"Valparaiso":["Vina del Mar","Valparaiso","Quilpue","Villa Alemana","San Antonio","Concon","Quillota","Los Andes","San Felipe"],"Metropolitana de Santiago":["Puente Alto","Maipu","Santiago","La Florida","Las Condes","Providencia","Nunoa","Vitacura","La Reina","San Miguel","Recoleta","Penalolen","San Bernardo","Pudahuel","Quilicura","Estacion Central","Macul","Independencia","Lo Barnechea","Renca"],"O'Higgins":["Rancagua","San Fernando","Rengo","Machali","Santa Cruz"],"Maule":["Talca","Curico","Linares","Maule","Constitucion"],"Nuble":["Chillan","San Carlos","Chillan Viejo","Coihueco","Bulnes"],"Biobio":["Concepcion","Los Angeles","Talcahuano","San Pedro de la Paz","Coronel","Chiguayante"],"La Araucania":["Temuco","Padre Las Casas","Villarrica","Angol","Lautaro"],"Los Rios":["Valdivia","La Union","Panguipulli","Rio Bueno","Mariquina"],"Los Lagos":["Puerto Montt","Osorno","Puerto Varas","Castro","Ancud"],"Aysen":["Coyhaique","Puerto Aysen","Cisnes","Chile Chico","Cochrane"],"Magallanes":["Punta Arenas","Puerto Natales","Porvenir","Cabo de Hornos","Primavera"]};
  var REGCODES = {"Arica y Parinacota":"AP","Tarapaca":"TA","Antofagasta":"AN","Atacama":"AT","Coquimbo":"CO","Valparaiso":"VS","Metropolitana de Santiago":"RM","O'Higgins":"LI","Maule":"ML","Nuble":"NB","Biobio":"BI","La Araucania":"AR","Los Rios":"LR","Los Lagos":"LL","Aysen":"AI","Magallanes":"MA"};

  /* ── Bundles ─────────────────────────────── */
  var heroPacks = section.querySelectorAll('#bsh-packs .bsh-pack');
  var bundles = [];
  heroPacks.forEach(function (p) {
    bundles.push({ idx: parseInt(p.dataset.idx), price: parseInt(p.dataset.price) || 0, variant: p.dataset.variant || '', name: p.dataset.name || '', pd: p.dataset.pd || '', cd: p.dataset.cd || '' });
  });
  var sel = 0;
  heroPacks.forEach(function (p) { if (p.classList.contains('selected')) sel = parseInt(p.dataset.idx); });
  function cur() { return bundles[sel] || bundles[0] || { price: 0, name: '', pd: '', cd: '', variant: '' }; }
  function fmt(n) { return '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function offPct(b) { var c = b.cd ? parseInt(b.cd.replace(/[^0-9]/g, '')) : 0; return (c && b.price && c > b.price) ? Math.round((1 - b.price / c) * 100) : 0; }

  function paint() {
    var b = cur();
    /* EasySell lee la variante activa desde la URL: sincroniza el pack elegido */
    if (CHECKOUT === 'easysell' && b.variant) { try { history.replaceState(null, '', location.pathname + '?variant=' + b.variant); } catch (e) {} }
    section.querySelectorAll('.bsh-pack').forEach(function (p) { p.classList.toggle('selected', parseInt(p.dataset.idx) === sel); });
    var el;
    el = section.querySelector('#bsh-price-now'); if (el) el.textContent = b.pd;
    el = section.querySelector('#bsh-price-old'); if (el) el.textContent = b.cd || '';
    el = section.querySelector('#bsh-price-save'); if (el) { var o = offPct(b); el.textContent = o > 0 ? '-' + o + '%' : ''; el.style.display = o > 0 ? '' : 'none'; }
    el = section.querySelector('#bsh-final-new'); if (el) el.textContent = b.pd;
    el = section.querySelector('#bsh-final-old'); if (el) el.textContent = b.cd || '';
    el = section.querySelector('#bsh-sticky-name'); if (el) el.textContent = b.name;
    el = section.querySelector('#bsh-sticky-price'); if (el) el.textContent = b.pd;
    el = section.querySelector('#bsh-sum-pack'); if (el) el.textContent = b.name;
    el = section.querySelector('#bsh-sum-total'); if (el) el.textContent = b.pd;
  }

  var atcFired = {};
  function trackATC(b) {
    if (typeof fbq === 'undefined' || !b) return;
    var k = String(b.idx); if (atcFired[k]) return; atcFired[k] = true;
    fbq('track', 'AddToCart', { content_name: PNAME + ' ' + b.name, content_ids: [String(b.variant)], content_type: 'product', value: b.price, currency: 'CLP' });
  }

  section.querySelectorAll('.bsh-pack').forEach(function (p) {
    /* Vitrina: en EasySell los packs NO seleccionan (la cantidad se elige en el popup); solo abren el popup (más abajo). */
    if (CHECKOUT !== 'easysell') p.addEventListener('click', function (e) { e.preventDefault(); sel = parseInt(p.dataset.idx); paint(); trackATC(cur()); });
  });
  paint();

  /* ViewContent al cargar */
  if (typeof fbq !== 'undefined') {
    var vc = cur();
    fbq('track', 'ViewContent', { content_name: PNAME, content_type: 'product', content_ids: [String(vc.variant)], value: vc.price, currency: 'CLP' });
  }

  /* ── Reveal al scroll (story + demos) ────── */
  var rvEls = section.querySelectorAll('.bsh-rv');
  if ('IntersectionObserver' in window && rvEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    rvEls.forEach(function (el) { io.observe(el); });
  } else {
    rvEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ── Nav móvil ───────────────────────────── */
  var mnav = section.querySelector('#bsh-mnav');
  var burger = section.querySelector('[data-toggle-mnav]');
  if (burger && mnav) burger.addEventListener('click', function () { mnav.classList.toggle('open'); });
  section.querySelectorAll('.bsh-mnav a').forEach(function (a) { a.addEventListener('click', function () { if (mnav) mnav.classList.remove('open'); }); });

  /* ── Acordeón FAQ ────────────────────────── */
  section.querySelectorAll('[data-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () { btn.parentElement.classList.toggle('open'); });
  });

  /* ── Regiones → Comunas ──────────────────── */
  var rSel = section.querySelector('#bsh-region'), cSel = section.querySelector('#bsh-comuna');
  if (rSel) {
    Object.keys(REGIONES).forEach(function (r) { var o = document.createElement('option'); o.value = r; o.textContent = r; rSel.appendChild(o); });
    rSel.addEventListener('change', function () {
      cSel.innerHTML = '<option value="">Selecciona</option>'; cSel.disabled = !this.value;
      (REGIONES[this.value] || []).forEach(function (c) { var o = document.createElement('option'); o.value = c; o.textContent = c; cSel.appendChild(o); });
    });
  }

  /* ── Modal abrir / cerrar ────────────────── */
  var icFired = false;
  function openForm() {
    modal.classList.add('open'); document.body.style.overflow = 'hidden'; if (mnav) mnav.classList.remove('open');
    var b = cur();
    if (typeof fbq !== 'undefined' && !icFired) { icFired = true; fbq('track', 'InitiateCheckout', { content_name: PNAME, content_ids: [String(b.variant)], content_type: 'product', value: b.price, currency: 'CLP', num_items: 1 }); }
    trackATC(b);
  }
  function closeForm() { modal.classList.remove('open'); document.body.style.overflow = ''; }
  if (CHECKOUT === 'easysell') {
    /* EasySell COD: los CTA abren el popup de la app (clase oficial es-popup-button-overwrite).
       El pixel se dispara igual que con el modal propio (InitiateCheckout + AddToCart). */
    section.querySelectorAll('[data-open-form], .bsh-pack').forEach(function (b) {
      b.classList.add('es-popup-button-overwrite');
      b.addEventListener('click', function () {
        var bb = b.hasAttribute('data-idx') ? (bundles[parseInt(b.dataset.idx)] || cur()) : cur();
        if (typeof fbq !== 'undefined' && !icFired) { icFired = true; fbq('track', 'InitiateCheckout', { content_name: PNAME, content_ids: [String(bb.variant)], content_type: 'product', value: bb.price, currency: 'CLP', num_items: 1 }); }
        trackATC(bb);
      });
    });
  } else {
    section.querySelectorAll('[data-open-form]').forEach(function (b) { b.addEventListener('click', openForm); });
  }
  section.querySelectorAll('[data-close-form]').forEach(function (b) { b.addEventListener('click', closeForm); });
  modal.addEventListener('click', function (e) { if (e.target === modal) closeForm(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeForm(); });

  /* ── Sticky ──────────────────────────────── */
  var sticky = section.querySelector('#bsh-sticky');
  if (sticky) { sticky.classList.add('show'); } /* siempre visible (como el sticky "Comprar" del competidor) */

  /* ── Validación RUT ──────────────────────── */
  function validRut(rut) { var c = rut.replace(/[^0-9kK]/g, '').toUpperCase(); if (c.length < 2) return false; var dv = c.slice(-1), b = c.slice(0, -1), su = 0, m = 2; for (var i = b.length - 1; i >= 0; i--) { su += parseInt(b[i]) * m; m = m === 7 ? 2 : m + 1; } var e = 11 - (su % 11); var x = e === 11 ? '0' : e === 10 ? 'K' : '' + e; return dv === x; }
  var rutInput = section.querySelector('#bsh-rut');
  if (rutInput) {
    rutInput.addEventListener('input', function () {
      var r = this.value.replace(/[^0-9kK]/g, '').toUpperCase(); if (!r) { this.value = ''; return; }
      var dv = r.slice(-1), b = r.slice(0, -1), o = '', c = 0; if (!b) { this.value = dv; return; }
      for (var i = b.length - 1; i >= 0; i--) { o = b[i] + o; if (++c === 3 && i > 0) { o = '.' + o; c = 0; } }
      this.value = o + '-' + dv;
    });
  }

  function setErr(id, on) { var el = section.querySelector('#' + id); if (!el) return; var f = el.closest('.bsh-f'); if (f) f.classList.toggle('err', on); }
  function val(id) { var el = section.querySelector('#' + id); return el ? el.value : ''; }
  function getCookie(n) { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? decodeURIComponent(m.pop()) : ''; }

  /* ── Submit ──────────────────────────────── */
  var submitBtn = section.querySelector('#bsh-submit');
  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      var btn = this; if (btn.disabled) return;
      var nombre = val('bsh-nombre').trim();
      var tel = val('bsh-tel').replace(/\s+/g, '');
      var rut = val('bsh-rut').trim();
      var region = val('bsh-region');
      var comuna = val('bsh-comuna');
      var dir = val('bsh-dir').trim();
      var email = val('bsh-email').trim();
      var ok = true;
      if (nombre.length < 5 || nombre.split(/\s+/).length < 2) { setErr('bsh-nombre', true); ok = false; } else setErr('bsh-nombre', false);
      if (!/^9\d{8}$/.test(tel)) { setErr('bsh-tel', true); ok = false; } else setErr('bsh-tel', false);
      if (!validRut(rut)) { setErr('bsh-rut', true); ok = false; } else setErr('bsh-rut', false);
      if (!region) { setErr('bsh-region', true); ok = false; } else setErr('bsh-region', false);
      if (!comuna) { setErr('bsh-comuna', true); ok = false; } else setErr('bsh-comuna', false);
      if (dir.length < 5 || !/\d/.test(dir)) { setErr('bsh-dir', true); ok = false; } else setErr('bsh-dir', false);
      if (email && !/.+@.+\..+/.test(email)) { setErr('bsh-email', true); ok = false; } else setErr('bsh-email', false);
      if (!ok) { var fe = modal.querySelector('.bsh-f.err'); if (fe) fe.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }

      var b = cur();
      var now = new Date(); var oid = 'BYD-' + now.getTime().toString(36).toUpperCase();
      var full = [dir, comuna, region].filter(Boolean).join(', ');
      var nota = 'Cliente: ' + nombre + ' | Tel: +56 ' + tel + ' | RUT: ' + rut + ' | Dir: ' + full + ' | Prod: ' + PNAME + ' ' + b.name + ' | Total: ' + b.pd + ' | Ref: ' + oid;
      var data = { producto: PNAME, nombre: nombre, telefono: '+56 ' + tel, rut: rut, email: email, direccion: full, calle: dir, region: region, regionCode: REGCODES[region] || '', comuna: comuna, pack: b.name, precio: b.pd, envio: 'Envio Gratis', nota: nota, fecha: now.toLocaleDateString('es-CL'), hora: now.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' }), orderId: oid, variantId: b.variant, totalNum: b.price, eventId: oid, fbp: getCookie('_fbp'), fbc: getCookie('_fbc'), userAgent: navigator.userAgent, sourceUrl: location.href };
      var wa = encodeURIComponent('Hola! Quiero pedir:\n' + oid + '\nProducto: ' + PNAME + ' ' + b.name + '\nTotal: ' + b.pd + '\nNombre: ' + nombre + '\nRUT: ' + rut + '\nTel: +56 ' + tel + '\nDirección: ' + full);
      var btnTxt = btn.textContent; btn.disabled = true; btn.textContent = 'Enviando…';

      function onSuccess() {
        if (typeof fbq !== 'undefined') fbq('track', 'Purchase', { value: b.price, currency: 'CLP', content_name: PNAME + ' ' + b.name, content_ids: [String(b.variant)], content_type: 'product', order_id: oid }, { eventID: oid });
        if (email) { try { var sf = new FormData(); sf.append('form_type', 'customer'); sf.append('utf8', '✓'); sf.append('contact[email]', email); sf.append('contact[tags]', 'newsletter,cod-form'); fetch('/contact', { method: 'POST', body: sf, keepalive: true }).catch(function () {}); } catch (e) {} }
        section.querySelector('#bsh-form-body').innerHTML = '<div style="text-align:center;padding:1.5rem 0"><div style="font-size:3rem">✅</div><h2 style="font-family:Fraunces,Georgia,serif;font-size:1.4rem;color:#0F172A;font-weight:900;margin:.25rem 0">¡Pedido recibido!</h2><p style="color:#16A34A;font-weight:600;font-size:.9rem;margin-bottom:1rem">Te contactamos en menos de 2 horas para confirmar.</p><div style="background:#F8FAFC;border-radius:10px;padding:1rem;text-align:left;font-size:.84rem;margin-bottom:1rem"><p><strong>Pedido:</strong> ' + oid + '</p><p><strong>Producto:</strong> ' + PNAME + ' ' + b.name + '</p><p><strong>Total a pagar:</strong> ' + b.pd + '</p></div><a href="https://wa.me/' + WA + '?text=' + wa + '" style="display:inline-flex;gap:.4rem;background:#25D366;color:#fff;font-weight:700;font-size:.9rem;padding:.7rem 1.4rem;border-radius:10px;text-decoration:none">💬 Confírmalo por WhatsApp →</a></div>';
      }
      function onFail() {
        btn.disabled = false; btn.textContent = btnTxt;
        var errEl = section.querySelector('#bsh-neterr');
        if (!errEl) { errEl = document.createElement('div'); errEl.id = 'bsh-neterr'; errEl.style.cssText = 'background:#FEF2F2;border:1px solid #FCA5A5;color:#B91C1C;border-radius:10px;padding:.7rem .9rem;font-size:.84rem;margin-top:.6rem'; btn.parentNode.insertBefore(errEl, btn.nextSibling); }
        errEl.style.display = ''; errEl.innerHTML = 'No pudimos enviar tu pedido. Inténtalo de nuevo o <a href="https://wa.me/' + WA + '?text=' + wa + '" target="_blank" rel="noopener" style="color:#B91C1C;font-weight:700;text-decoration:underline">pídelo por WhatsApp →</a>';
      }
      function send() { return fetch(WEBHOOK, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); }); }
      function withTimeout(p, ms) { return Promise.race([p, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]); }
      withTimeout(send(), 12000).then(onSuccess).catch(function () { withTimeout(send(), 12000).then(onSuccess).catch(onFail); });
    });
  }

  /* ── Urgencia: cuenta regresiva al fin del día (hora local) ── */
  var cds = section.querySelectorAll('[data-countdown]');
  if (cds.length) {
    var tickCd = function () {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var hh = Math.floor(s / 3600), mm = Math.floor((s % 3600) / 60), ss = s % 60;
      var p2 = function (n) { return n < 10 ? '0' + n : '' + n; };
      var txt = p2(hh) + ':' + p2(mm) + ':' + p2(ss);
      cds.forEach(function (el) { el.textContent = txt; });
    };
    tickCd(); setInterval(tickCd, 1000);
  }

  /* ── Urgencia: "X viendo ahora" (rango plausible, deriva lenta) ── */
  var lvEls = section.querySelectorAll('.bsh-live-n');
  if (lvEls.length) {
    var lvN = 16 + Math.floor(Math.random() * 18); /* 16–33 */
    var drift = function () {
      lvN += Math.floor(Math.random() * 5) - 2; /* -2..+2 */
      if (lvN < 8) lvN = 8; if (lvN > 41) lvN = 41;
      lvEls.forEach(function (el) { el.textContent = lvN; });
    };
    drift(); setInterval(drift, 4500 + Math.floor(Math.random() * 3000));
  }

  /* ── Antes/Después: slider deslizante ── */
  section.querySelectorAll('.bsh-ba').forEach(function (ba) {
    var r = ba.querySelector('.bsh-ba-range');
    if (!r) return;
    var upd = function () { ba.style.setProperty('--pos', r.value + '%'); };
    r.addEventListener('input', upd); upd();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
